"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    {
        key: 'validateOn',
        ignore: true
    },
    {
        key: 'unique',
        ignore: true
    },
];
